module.exports = require("babel-runtime/helpers/slicedToArray");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/slicedToArray"
// module id = 101
// module chunks = 0 1 2